import { IconBuilding } from "@tabler/icons-react";
import { type MRT_ColumnDef } from "mantine-react-table-open";
import { MantineIconCell } from "../../../mantine/mrt/components/cell/MantineIconCell";
import { type Todo } from "../../../utils/backend-types";
import { TodosListColumnKeys } from "../TodoTable/TodoTable";

const PERSON_EMPTY = "empty";

export function getPersonColumn(todos: Array<Todo>): MRT_ColumnDef<Todo> {
  const allPersons = todos.map((todo) => todo.person);
  const sortedNonNullPersons = allPersons
    .filter((dueDate) => dueDate !== null)
    .sort((personA, personB) => (personA ?? "").localeCompare(personB ?? ""));
  const uniqueUsedPersons = Array.from<string>(new Set(sortedNonNullPersons));
  const usedPersons = Array.from(uniqueUsedPersons);

  return {
    accessorKey: TodosListColumnKeys.Person,
    header: "Verpflichtetes Unternehmen",
    enableCellHoverReveal: true,
    enableGrouping: false,
    Cell: ({ renderedCellValue }) =>
      renderedCellValue ? (
        <MantineIconCell
          IconComponent={IconBuilding}
          renderedCellValue={renderedCellValue}
        />
      ) : null,
    filterVariant: "multi-select",
    filterFn: (row, _, filterValue) => {
      if (filterValue.length === 0) {
        return true;
      }
      if (filterValue.includes(PERSON_EMPTY) && row.original.person === null) {
        return true;
      }
      return filterValue.includes(row.original.person);
    },
    filterTooltipValueFn: (value) =>
      value === PERSON_EMPTY ? "(kein verpflichtetes Unternehmen)" : value,
    mantineFilterMultiSelectProps: {
      data: [
        { value: PERSON_EMPTY, label: "(kein verpflichtetes Unternehmen)" }
      ].concat(
        usedPersons.map((company) => ({
          value: company,
          label: company
        }))
      )
    }
  };
}
